module.exports = __webpack_public_path__ + "media/images/icons/ic-avatar-male-white-83ea405dd07677a4d02ef878e16352e1.svg";